import { render, staticRenderFns } from "./OrganizationPackage.vue?vue&type=template&id=6787bdbd&scoped=true"
import script from "./OrganizationPackage.vue?vue&type=script&lang=js"
export * from "./OrganizationPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6787bdbd",
  null
  
)

export default component.exports